export default function($uibModalInstance, APIEndpointService, AccountSitesService, pointOfInterestTypeArray) {
    'ngInject';

    var vm = this;
    vm.cancelNew = $uibModalInstance.dismiss;
    vm.saveNew = saveNew;
    vm.newData = {
        key: 'html',
        tags: [],
        siteId: AccountSitesService.getSelectedSiteId()
    };
    vm.poiTypes = pointOfInterestTypeArray;

    function saveNew() {
        vm.isSaving = true;
		$uibModalInstance.freeze(true);

        APIEndpointService.pointOfInterest.create(vm.newData).$promise
            .then(function(res) {
				$uibModalInstance.close(res);
            })
            .catch(function() {
				$uibModalInstance.freeze(false);
                vm.isSaving = false;
            });
    }
};
